import { Col, Descriptions, Row } from "antd";
import moment from "moment";
import { useCallback } from "react";
import { OrderItem } from "../../../../model/OrderItem";
import ReservationDetail from "../../../../model/ReservationDetail";
import RepairStatusBadge from "../../../../pages/Reservation/components/RepairStatusBadge";
import { ProductStatusType } from "../Expended/Products/ProductStatus";
import { CardHeader, CardTitle, CustomCard } from "./Card.styled";
import { CustomDescription, DescriptionTitle } from "./Description.styled";
import { ProductInfo } from "./ProductInfo";

interface OrderInfoProps {
  dataForm?: ReservationDetail;
  isMaster?: boolean;
}
export const OrderInfo: React.FC<OrderInfoProps> = ({ dataForm, isMaster }) => {
  const parsingProductInfo = useCallback(
    (record: OrderItem[], type: ProductStatusType) => {
      const typeItems = record?.filter((item) => item.productType === type);

      if (type === "ENGINE_OIL") {
        return (
          typeItems?.reduce((a, b) => {
            const items = b.orderItemProductOptions || [];

            const arr = items.map((item) => ({
              ...item,
              orderItemStatus: b.orderItemStatus,
              orderItemReturnStatus: b.orderItemReturnStatus,
              orderItemName: b.orderItemName,
            }));

            return a.concat(...arr);
          }, [] as any) || []
        );
      }

      return typeItems;
    },
    [dataForm]
  );

  return (
    <CustomCard title={<CardTitle>주문정보</CardTitle>}>
      <Descriptions column={2} colon={false} labelStyle={{ width: 140 }}>
        <Descriptions.Item
          label={<DescriptionTitle>주문번호</DescriptionTitle>}
        >
          {dataForm?.repair.repairNo || "-"}
        </Descriptions.Item>
        <Descriptions.Item
          label={<DescriptionTitle>주문일시</DescriptionTitle>}
        >
          {dataForm?.order.orderedAt
            ? moment(dataForm?.order.orderedAt).format("YYYY-MM-DD HH:mm")
            : "-"}
        </Descriptions.Item>
        {isMaster && (
          <>
            <Descriptions.Item
              label={<DescriptionTitle>매장명</DescriptionTitle>}
            >
              {dataForm?.repairShop?.displayName || "-"}
            </Descriptions.Item>
            <Descriptions.Item
              label={<DescriptionTitle>매장코드</DescriptionTitle>}
            >
              {dataForm?.repairShop?.repairShopCode || "-"}
            </Descriptions.Item>
          </>
        )}
        <Descriptions.Item
          label={<DescriptionTitle>예약일시</DescriptionTitle>}
        >
          {dataForm?.repair.reservedAt
            ? moment(dataForm?.repair.reservedAt).format("YYYY-MM-DD HH:mm")
            : "-"}
        </Descriptions.Item>
        <Descriptions.Item
          label={<DescriptionTitle>예약상태</DescriptionTitle>}
        >
          <RepairStatusBadge status={dataForm?.repair.repairStatus} />
        </Descriptions.Item>
        <Descriptions.Item
          label={<DescriptionTitle>상품정보</DescriptionTitle>}
          span={2}
        >
          <Row
            justify="space-between"
            gutter={[0, 24]}
            style={{ width: "100%" }}
          >
            {parsingProductInfo(
              dataForm?.repair.orderItems as OrderItem[],
              "TIRE"
            )?.length > 0 && (
              <Col span={24}>
                <Descriptions
                  layout="vertical"
                  colon={false}
                  column={2}
                  style={{ width: "100%" }}
                  contentStyle={{ width: "100%", display: "block" }}
                >
                  <Descriptions.Item
                    label={<CardHeader>타이어 장착</CardHeader>}
                    span={2}
                  >
                    <ProductInfo
                      dataSource={parsingProductInfo(
                        dataForm?.repair.orderItems as OrderItem[],
                        "TIRE"
                      )}
                      type="TIRE"
                    />
                  </Descriptions.Item>
                </Descriptions>
              </Col>
            )}
            {parsingProductInfo(
              dataForm?.repair.orderItems as OrderItem[],
              "ENGINE_OIL"
            )?.length > 0 && (
              <Col span={24}>
                <Descriptions
                  layout="vertical"
                  colon={false}
                  column={2}
                  style={{ width: "100%" }}
                  contentStyle={{ width: "100%", display: "block" }}
                >
                  <Descriptions.Item
                    label={
                      <CardHeader>
                        엔진오일교환
                        {` | ${
                          parsingProductInfo(
                            dataForm?.repair.orderItems as OrderItem[],
                            "ENGINE_OIL"
                          )[0].orderItemName
                        }`}
                      </CardHeader>
                    }
                    span={2}
                  >
                    <ProductInfo
                      dataSource={parsingProductInfo(
                        dataForm?.repair.orderItems as OrderItem[],
                        "ENGINE_OIL"
                      )}
                      type="ENGINE_OIL"
                    />
                  </Descriptions.Item>
                </Descriptions>
              </Col>
            )}
          </Row>
        </Descriptions.Item>
        <Descriptions.Item
          label={<DescriptionTitle>추가정보</DescriptionTitle>}
          span={2}
        >
          <Row
            justify="space-between"
            gutter={[0, 24]}
            style={{ width: "100%" }}
          >
            <Col span={24}>
              <div style={{ position: "relative", display: "block" }}>
                <CustomDescription
                  column={{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}
                  bordered
                  style={{ display: "grid" }}
                  labelStyle={{ width: 200 }}
                >
                  <Descriptions.Item label="휠 얼라인먼트">
                    {parsingProductInfo(
                      dataForm?.repair.orderItems as OrderItem[],
                      "ETC"
                    )?.length > 0
                      ? "휠 얼라인먼트 해주세요"
                      : "휠 얼라인먼트 안해요"}
                  </Descriptions.Item>
                  <Descriptions.Item label="방문방법">
                    {dataForm?.valet && Object.keys(dataForm?.valet).length > 0
                      ? "발렛 기사님이 방문해요"
                      : "고객님이 직접 방문해요"}
                  </Descriptions.Item>
                  <Descriptions.Item label="차량 구분 (수입차/국산차)">
                    {dataForm?.repair.isDomestic ? "국산차" : "수입차"}
                  </Descriptions.Item>
                  <Descriptions.Item label="작업일 (평일/주말)">
                    {dataForm?.repair.isWeekend ? "주말" : "평일"}
                  </Descriptions.Item>
                </CustomDescription>
              </div>
            </Col>
          </Row>
        </Descriptions.Item>
      </Descriptions>
    </CustomCard>
  );
};
